module.exports = __webpack_public_path__ + "711884444cce6e8ea0deba1088ce6f55.glb";